/**
 * Alert component type definitions
 * @module shared/types/alert.types
 */

/**
 * Alert variant enum for semantic feedback styling
 */
export enum AlertVariant {
  /**
   * Default info alert
   */
  Default = 'default',

  /**
   * Destructive/error alert
   */
  Destructive = 'destructive',

  /**
   * Warning alert
   */
  Warning = 'warning',

  /**
   * Success alert
   */
  Success = 'success',

  /**
   * Informational alert
   */
  Info = 'info',
}

/**
 * Type guard to check if a value is a valid AlertVariant
 */
export function isAlertVariant(value: unknown): value is AlertVariant {
  return Object.values(AlertVariant).includes(value as AlertVariant);
}

/**
 * Get all AlertVariant values as an array
 */
export function getAllAlertVariants(): readonly AlertVariant[] {
  return Object.values(AlertVariant);
}
